import React from "react";
import facebook from "../../Resource/image/icons/facebook_32.png";
import linkedin from "../../Resource/image/icons/linkedin_32.png";
import instagram from "../../Resource/image/icons/instagram_32.png";
import twitter from "../../Resource/image/icons/twitter_32.png";
// import file from "../../Resource/Documents/Manikandan.AL.pdf";
import SocialMediaElements from "../SocialMedia/SocialMediaElements";

export default function Footer() {
  return (
    <footer className="bg-red h-63 w-full  mt-5 p-20  ">
      <div className="md:flex md:justify-between justify-center md:items-center">
        <div className="flex flex-col items-center justify-center ">
          <h1 className="md:text-3xl text-2xl text-center">
            Follow me on social media
          </h1>
          <div className="flex mt-7 justify-center  text-center items-center  ">
            <SocialMediaElements
              icon={linkedin}
              url="https://in.linkedin.com/"
              style={"hover:text-blue"}
            />
            <SocialMediaElements
              icon={instagram}
              url="https://www.instagram.com/"
              style={"hover:text-red"}
            />
            <SocialMediaElements
              icon={facebook}
              url="https://www.facebook.com/"
              style={"hover:text-blue"}
            />
            <SocialMediaElements
              icon={twitter}
              url="https://twitter.com/"
              style={"hover:text-blue"}
            />
          </div>
        </div>
        <div className="mt-10">
          <p className="text-center">©2022 MKD. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}
